import {
  TEMPLATE_VALUE_TYPES as TYPES, REGIONS, BACKGROUND_IMAGE_POSITION, BACKGROUND_IMAGE_SCALE
} from 'shared/constants';

const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Main Content Secion'
  },
  {
    slotId: 'right-col',
    label: 'Right Column'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: TYPES.STRING,
    key: 'url',
    label: 'URL',
  },
  {
    type: TYPES.ENUM,
    key: 'region',
    label: 'Region',
    options: REGIONS
  },
  {
    type: TYPES.BOOLEAN,
    key: 'featured',
    label: 'Featured Event',
  },
  {
    type: TYPES.DATETIME,
    key: 'start_date',
    label: 'Event Start Date'
  },
  {
    type: TYPES.DATETIME,
    key: 'end_date',
    label: 'Event End Date'
  },
  {
    type: TYPES.STRING,
    key: 'event_name',
    label: 'Event Name'
  },
  {
    type: TYPES.STRING,
    key: 'event_description',
    label: 'Event Description'
  },
  {
    type: TYPES.STRING,
    key: 'event_location',
    label: 'Event Location'
  },
  {
    type: TYPES.STRING,
    key: 'event_address',
    label: 'Event Address'
  },
  {
    type: TYPES.STRING,
    key: 'background_image_url',
    label: 'Background Image'
  },
  {
    type: TYPES.ENUM,
    key: 'background_position',
    label: 'Background Position',
    options: BACKGROUND_IMAGE_POSITION,
    default: 'CENTER CENTER'
  },
  {
    type: TYPES.ENUM,
    key: 'background_scale',
    label: 'Background Scale',
    options: BACKGROUND_IMAGE_SCALE,
    default: 'auto'
  },
  {
    type: TYPES.ARRAY,
    key: 'social_share',
    label: 'Social Share',
    children: [
      {
        type: TYPES.STRING,
        key: 'url',
        label: 'Url',
      },
      {
        type: TYPES.STRING,
        key: 'icon',
        label: 'Icon'
      }
    ],
    default: [
      { url: 'https://www.linkedin.com/shareArticle?mini=true&url={page url}&title={article title}&summary={short description}', icon: 'ff-icon-social-linkedin' },
      { url: 'https://twitter.com/share?url={URL}&text={article title} @FaradayFuture', icon: 'ff-icon-social-twitter' },
      { url: 'https://www.facebook.com/sharer/sharer.php?u={URL}', icon: 'ff-icon-social-facebook' },
      { url: 'mailto:?subject={article title}&body={URL}', icon: 'ff-icon-mail' },
      { url: 'http://service.weibo.com/share/share.php?url={URL}&title={article title} @FaradayFuture&appkey=1343713053&pic=&searchPic=false', icon: 'ff-icon-social-weibo' },
      { url: '{URL}', icon: 'ff-icon-social-wechat' }
    ]
  }
];

export default {
  id: 'Event',
  name: 'EventDetails',
  creator: 'Thomas Davison',
  updatedBy: 'Thomas Davison',
  createdAt: 1566510712000,
  updatedAt: 1566510712000,
  slots,
  templateSettings,
  defaultProps
};
